import React from 'react';

export default
<g fillRule="evenodd">
    <path d="M6 6h2v12H6zm3.5 6l8.5 6V6z"/>
    <path d="M0 0h24v24H0z" fill="none"/>
</g>;
